import React, { useState, useEffect } from "react";
import { Container, Button } from "react-bootstrap";

import DeleteConfirmationModal from "../components/DeleteConfirmationModal";
import { Plus } from "react-bootstrap-icons";
import NavbarTop from "../components/NavbarTop";
import NavbarBottom from "../components/NavbarBottom";
import { useNavigate } from "react-router-dom";
import { fetchAPI } from "../utils/fetchAPI";
import QrList from "../components/QrList";
import EditQrForm from "../components/EditQrForm";
import { WhiteBoxWrapper } from "../components/Login.style";

interface QrCode {
  qrCode: string;
  entityId: number;
  entityType: number;
  entityName: string;
}

const QrManagement: React.FC = () => {
  const [qrCodes, setQrCodes] = useState<QrCode[]>([]);
  const [loading, setLoading] = useState(true);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedQr, setSelectedQr] = useState<QrCode | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchQrCodes();
  }, []);

  const fetchQrCodes = async () => {
    try {
      const data = await fetchAPI("GET", "qr.php");
      if (data.success) {
        setQrCodes(data.data);
      } else {
        console.error("Błąd podczas pobierania kodów QR:", data.message);
      }
    } catch (error) {
      console.error("Błąd podczas pobierania kodów QR:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditQr = async (data: QrCode) => {
    try {
      const result = await fetchAPI("PUT", "updateQr.php", data);
      if (result.success) {
        await fetchQrCodes();
        setShowEditForm(false);
        setSelectedQr(null);
      } else {
        console.error("Błąd podczas aktualizacji kodu QR:", result.message);
      }
    } catch (error) {
      console.error("Błąd podczas aktualizacji kodu QR:", error);
    }
  };

  const handleDeleteQr = async () => {
    if (!selectedQr) return;

    setIsDeleting(true);
    try {
      const result = await fetchAPI("DELETE", "deleteQr.php", { qrCode: selectedQr.qrCode });
      if (result.success) {
        await fetchQrCodes();
        setShowDeleteModal(false);
        setSelectedQr(null);
      } else {
        console.error("Błąd podczas usuwania kodu QR:", result.message);
      }
    } catch (error) {
      console.error("Błąd podczas usuwania kodu QR:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <NavbarTop />
      <Container fluid className="mt-4 mb-5">
        <WhiteBoxWrapper>
          <div className="row align-items-center">
            <div className="col">
              <h2>
                <b>Zarządzanie kodami QR</b>
              </h2>
            </div>
            <div className="col-auto">
              <Button variant="primary" onClick={() => navigate("/add-qr")}>
                <Plus className="me-2" />
                Dodaj kod QR
              </Button>
            </div>
          </div>
        </WhiteBoxWrapper>

        <QrList
          qrCodes={qrCodes}
          loading={loading}
          onEdit={(qr: QrCode) => {
            setSelectedQr(qr);
            setShowEditForm(true);
          }}
          onDelete={(qr: QrCode) => {
            setSelectedQr(qr);
            setShowDeleteModal(true);
          }}
        />

        <EditQrForm
          open={showEditForm}
          onClose={() => setShowEditForm(false)}
          onSubmit={handleEditQr}
          qrCode={selectedQr}
        />

        <DeleteConfirmationModal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          onConfirm={handleDeleteQr}
          itemName={selectedQr?.qrCode || ""}
          isLoading={isDeleting}
        />
      </Container>
      <NavbarBottom />
    </>
  );
};

export default QrManagement;
